/* Zakdor - offers surface.
   No entry popup: nothing interrupts a visitor who has just landed.
   Instead there are two quiet touchpoints -
     1. a slim OFFERS tab on the right edge that opens the offers panel,
        and that the shopper can dismiss for a week;
     2. a bundle progress bar that appears only inside the cart, where the
        "add one more item" decision is actually being made.
   The light theme block at the bottom re-skins the older offers panel so
   both surfaces look like one thing. */
(function(){
  if (window.__axBundle) return;
  window.__axBundle = 1;

  var TAB_KEY = 'axOffersTabHidden';
  var TAB_GAP = 604800000; /* 7 days */

  function hidden(){
    try {
      var v = localStorage.getItem(TAB_KEY);
      if (!v) return false;
      return (+new Date() - parseInt(v, 10)) < TAB_GAP;
    } catch(e){ return false; }
  }
  function stamp(){
    try { localStorage.setItem(TAB_KEY, '' + (+new Date())); } catch(e){}
  }

  function offers(){
    try {
      var el = document.getElementById('axOffersData');
      if (!el) return [];
      var d = JSON.parse(el.textContent || '{}');
      var a = [], i;
      for (i = 0; i < (d.items || []).length; i++){
        if (d.items[i] && d.items[i].code) a.push(d.items[i]);
      }
      return a;
    } catch(e){ return []; }
  }
  /* the bundle offer = the one whose wording names a quantity; else the 3rd */
  function bundle(list){
    var i, t;
    for (i = 0; i < list.length; i++){
      t = ((list[i].title || '') + ' ' + (list[i].short || '')).toLowerCase();
      if (/(\d+)\s*items?/.test(t)) return list[i];
    }
    return list[2] || null;
  }
  function need(o){
    var m = /(\d+)\s*items?/.exec(((o.title || '') + ' ' + (o.short || '')).toLowerCase());
    var n = m ? parseInt(m[1], 10) : 3;
    return (n > 0 && n < 20) ? n : 3;
  }
  function esc(s){
    return (s == null ? '' : '' + s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  var CSS =
  /* ---- right-edge offers tab ---- */
    '.axot-w{position:fixed;right:0;top:50%;transform:translateY(-50%);z-index:9150;'
  + 'display:flex;flex-direction:column;align-items:flex-end;gap:4px;font-family:inherit}'
  + '.axot{display:flex;flex-direction:column;align-items:center;gap:7px;padding:16px 9px;'
  + 'border:0;border-right:0;border-radius:14px 0 0 14px;cursor:pointer;font-family:inherit;'
  + 'background:#fff;color:#0A1730;box-shadow:0 10px 30px rgba(0,0,0,.34);'
  + 'transition:padding .25s ease,background .25s ease}'
  + '.axot:hover{padding-right:13px}'
  + '.axot svg{width:18px;height:18px;fill:none;stroke:#0A1730;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}'
  + '.axot span{writing-mode:vertical-rl;font-size:.6rem;letter-spacing:.24em;font-weight:800}'
  + '.axot-x{width:22px;height:22px;margin-right:5px;border:0;border-radius:50%;cursor:pointer;'
  + 'background:rgba(255,255,255,.16);color:#fff;font-size:.72rem;line-height:1;font-family:inherit;'
  + 'display:grid;place-items:center;transition:background .2s}'
  + '.axot-x:hover{background:rgba(255,255,255,.34)}'
  + '@media(max-width:749px){.axot{padding:13px 7px;gap:6px}.axot svg{width:16px;height:16px}'
  + '.axot span{font-size:.55rem;letter-spacing:.2em}}'
  /* ---- cart bundle progress ---- */
  + '.axbb{display:block;box-sizing:border-box;width:100%;margin:0 0 18px;padding:14px 16px;'
  + 'background:#0E2044;border:1px solid rgba(255,255,255,.14);text-decoration:none;'
  + 'font-family:inherit;transition:border-color .25s ease,background .25s ease}'
  + '.axbb .t{display:flex;align-items:center;gap:11px}'
  + '.axbb i{flex:0 0 auto;width:22px;height:22px;display:grid;place-items:center}'
  + '.axbb i svg{width:19px;height:19px;fill:none;stroke:#fff;stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round}'
  + '.axbb b{display:block;color:#fff;font-size:.78rem;font-weight:800;letter-spacing:.06em;line-height:1.4}'
  + '.axbb small{display:block;margin-top:3px;color:#8FA3C8;font-size:.72rem;font-weight:400;letter-spacing:.01em}'
  + '.axbb .pips{display:flex;gap:5px;margin-top:11px}'
  + '.axbb .pips u{flex:1;height:3px;background:rgba(255,255,255,.16);text-decoration:none;'
  + 'transition:background .3s ease}'
  + '.axbb .pips u.on{background:#fff}'
  + '.axbb.done{background:#fff;border-color:#fff}'
  + '.axbb.done b{color:#0A1730}'
  + '.axbb.done small{color:#4B5B78}'
  + '.axbb.done i svg{stroke:#0A1730}'
  + '.axbb.done .pips u{background:rgba(10,23,48,.18)}'
  + '.axbb.done .pips u.on{background:#0A1730}'
  /* ---- older "Offers for you" panel, light and square ---- */
  + '.ax-ov{background:rgba(10,23,48,.55)!important}'
  + '.ax-ovc{background:#fff!important;border:1px solid #E4E8EF!important;border-radius:0!important;box-shadow:0 26px 64px rgba(10,23,48,.22)!important;padding:36px 32px 26px!important}'
  + '.ax-ovx{top:0!important;right:0!important;width:44px!important;height:44px!important;border-radius:0!important;background:transparent!important;color:#95A0B4!important}'
  + '.ax-ovx:hover{background:#F1F4F9!important;color:#0A1730!important}'
  + '.ax-ovh{color:#0A1730!important}'
  + '.ax-ovs{color:#5A6880!important}'
  + '.ax-offr{border:1px dashed #C3CCDC!important;border-radius:0!important;background:#F7F9FC!important;padding:15px 16px!important}'
  + '.ax-offr b{color:#0A1730!important}'
  + '.ax-offr small{color:#5A6880!important}'
  + '.ax-offr .cd{background:#fff!important;border:1px solid #DCE3EC!important;color:#0A1730!important;border-radius:0!important}'
  + '.ax-cp{background:#0A1730!important;color:#fff!important;border-radius:0!important}'
  + '.ax-cp:hover{background:#16305F!important;color:#fff!important}'
  + '.ax-ovf{color:#95A0B4!important}';

  var cssDone = false;
  function styles(){
    if (cssDone) return;
    cssDone = true;
    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  /* ---------------- right-edge offers tab ---------------- */
  function tab(){
    if (hidden()) return;
    if (!offers().length) return;
    if (document.querySelector('.axot-w')) return;

    var w = document.createElement('div');
    w.className = 'axot-w';
    w.innerHTML =
      '<button class="axot-x" type="button" aria-label="Hide offers for a week">&#10005;</button>'
      + '<button class="axot" type="button" aria-label="See all offers">'
      + '<svg viewBox="0 0 24 24"><path d="M20 12v9H4v-9"/><path d="M2 7h20v5H2z"/><path d="M12 21V7"/>'
      + '<path d="M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7z"/></svg>'
      + '<span>OFFERS</span></button>';
    document.body.appendChild(w);

    w.addEventListener('click', function(e){
      if (e.target.closest('.axot-x')) {
        stamp();
        w.parentNode && w.parentNode.removeChild(w);
        return;
      }
      if (e.target.closest('.axot')) {
        if (typeof window.axShowOffers === 'function') window.axShowOffers();
      }
    });
  }

  /* ---------------- bundle progress, inside the cart only ---------------- */
  var LIST = null, OFF = null, NEED = 3;

  function bar(count){
    var left = NEED - count;
    var done = left <= 0;
    var pips = '', i;
    for (i = 0; i < NEED; i++) pips += '<u class="' + (i < count ? 'on' : '') + '"></u>';

    var head, sub;
    if (done) {
      head = esc(OFF.short || OFF.title) + ' UNLOCKED';
      sub = 'Tap to apply code ' + esc(OFF.code) + ' &mdash; it stays on through checkout.';
    } else {
      head = 'ADD ' + left + ' MORE ITEM' + (left > 1 ? 'S' : '') + ' &middot; SAVE ' + esc(OFF.short || OFF.title);
      sub = 'Mix any products across the store. Free shipping either way.';
    }

    var icon = done
      ? '<path d="M20 6L9 17l-5-5"/>'
      : '<path d="M20 12v9H4v-9"/><path d="M2 7h20v5H2z"/><path d="M12 21V7"/>';

    return '<div class="t"><i><svg viewBox="0 0 24 24">' + icon + '</svg></i>'
      + '<span><b>' + head + '</b><small>' + sub + '</small></span></div>'
      + '<div class="pips">' + pips + '</div>';
  }

  function place(root, count){
    if (!root) return;
    var el = root.querySelector('.axbb');
    var done = count >= NEED;
    var tag = done ? 'a' : 'div';

    if (el && el.tagName.toLowerCase() !== tag) { el.parentNode.removeChild(el); el = null; }
    if (!el) {
      el = document.createElement(tag);
      el.className = 'axbb';
      root.insertBefore(el, root.firstChild);
    }
    el.className = 'axbb' + (done ? ' done' : '');
    if (done) el.setAttribute('href', '/discount/' + encodeURIComponent(OFF.code) + '?redirect=/cart');
    else el.removeAttribute('href');
    el.innerHTML = bar(count);
  }

  function roots(){
    var out = [];
    var p = document.getElementById('shopify-section-cart-section');
    if (p) out.push(p);
    var d = document.getElementById('cart-drawer');
    if (d) out.push(d);
    return out;
  }

  var busy = false, timer = null;
  function refresh(){
    if (busy || !OFF) return;
    var r = roots();
    if (!r.length) return;
    busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(res){ return res.json(); })
      .then(function(c){
        busy = false;
        var n = c && c.item_count ? c.item_count : 0;
        for (var i = 0; i < r.length; i++){
          var old = r[i].querySelector('.axbb');
          if (!n) { if (old) old.parentNode.removeChild(old); continue; }
          place(r[i], n);
        }
      })
      .catch(function(){ busy = false; });
  }
  function schedule(){
    clearTimeout(timer);
    timer = setTimeout(refresh, 200);
  }

  function boot(){
    styles();
    LIST = offers();
    OFF = bundle(LIST);
    if (OFF) NEED = need(OFF);
    tab();
    if (OFF) {
      schedule();
      document.addEventListener('shopify:section:load', schedule);
      document.addEventListener('shopify:cart:lines-update', schedule);
      document.addEventListener('shopify:cart:discount-update', schedule);
      document.addEventListener('theme-drawer:open', schedule);
      document.addEventListener('cart:refresh', schedule);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
